import noop from 'lodash/noop';

const LOCATION_FIELDS = [
  'href',
  'origin',
  'protocol',
  'host',
  'hostname',
  'port',
  'pathname',
  'search',
  'hash',
] as const;

type LocationField = (typeof LOCATION_FIELDS)[number];

// Every read goes to the live location at ACCESS time (never captured at module or
// construction time — cross-origin frames can throw on access, and SSR/native have no
// window at all), so building this object is always safe to do during import.
function readLocationField(field: LocationField): string {
  try {
    if (typeof window === 'undefined') return '';
    return window.location[field];
  } catch {
    return '';
  }
}

let cachedMirror: Record<string, unknown> | null = null;

export function getLocationMirror(): Record<string, unknown> {
  if (cachedMirror) return cachedMirror;
  const mirror: Record<string, unknown> = {};
  for (const field of LOCATION_FIELDS) {
    Object.defineProperty(mirror, field, {
      enumerable: true,
      get: () => readLocationField(field),
      // The compiled expressions run under "use strict", where assigning to a
      // getter-only property throws — a no-op setter keeps "location.href = x" silent.
      set: noop,
    });
  }
  mirror.assign = noop;
  mirror.replace = noop;
  mirror.reload = noop;
  mirror.toString = () => readLocationField('href');
  cachedMirror = mirror;
  return mirror;
}
